/* ═══════════════════════════════════════════════════════════
   File: wgs-buybox-video.js  ·  v6.3
   Theme System: Achairgo (ACG) PDP Buy-Box Module

   v6.3 Changelog（在 v6.2 基础上，修复"挽留弹窗绕过订阅验证直接发码"
   的严重安全漏洞）:
   ── 修复 ──────────────────────────────────────────────────
   ·【严重安全漏洞修复】原 acgWgsApplyAndCheckout() 函数在用户点击
     "未领券挽留弹窗"里的"Apply Discount & Checkout"按钮时，会直接
     调用 acgWgsMarkSubscribed() 发码，完全没有经过订阅意图置信度
     状态机的任何判定——等同于任何人只要点两下鼠标（立即购买 → 挽留
     弹窗按钮），完全不需要真的点开订阅链接，就能拿到 VIP 折扣价下单。
     该函数已删除，替换为 acgWgsClaimModalSubscribeAndCheckout()：
     点击后不再自己发码，而是程序化触发真实的订阅按钮点击，复用完整
     的 PENDING → HIGH_CONF / AMBIGUOUS / UNRESOLVED 判定状态机，只有
     状态机真正判定通过（acgWgsResolveGrant 被调用）才会自动继续结账。
   ── 沿用 v6.2 的修复 ────────────────────────────────────────
   · ESC 键 / 遮罩点击 / X 关闭按钮 关闭 AMBIGUOUS 或 UNRESOLVED 确认
     弹层时，统一走 acgWgsRequestDismiss()，避免状态机卡死导致订阅
     按钮无法再次点击。
   · 用户第一次尝试"静默关闭"确认弹层时，展示"损失厌恶"挽留文案，
     第二次坚持关闭才真正放行。
   ═══════════════════════════════════════════════════════════ */

window.acgWgsState = window.acgWgsState || {};

function acgWgsGetState(scopeId) {
  if (!window.acgWgsState[scopeId]) {
    window.acgWgsState[scopeId] = {
      playlist: [],
      pipIndex: 0,
      pipTimer: null,
      isHovered: false,
      activeVariantId: null,
      pipAutoplayed: false,
      pipDismissed: false,
      lastFocus: null,
      subAttemptTimer: null,
      pdpPollTimer: null,
      visListenerBound: false,

      /* ══ 订阅意图置信度状态机字段 ══ */
      subDecisionState: 'idle',   // idle | pending | resolved
      desktopPollTimer: null,
      desktopT0: null,
      desktopBlurred: false,
      resolveFallbackTimer: null,
      mobileTrackingArmed: false,
      _mobileVisHandler: null,

      /* ══ 挽留式退出拦截标记 ══ */
      exitWarnShown: false,

      /* ══ v6.3 新增：挽留弹窗"先订阅再结账"链路所需字段 ══
         用户在未订阅状态下点击"立即购买"→挽留弹窗→"订阅并解锁"，
         必须先走完真实订阅判定，判定通过后才自动继续结账，
         这两个字段用于在判定成功的回调里找回"用户原本想买的商品"。 */
      autoCheckoutAfterGrant: false,
      pendingCheckoutVariantId: null
    };
  }
  return window.acgWgsState[scopeId];
}

/* ═══════════════════════════════════════════════════════════
   订阅意图置信度评分状态机
   PENDING → HIGH_CONF(直接发码) / AMBIGUOUS(二次确认) / UNRESOLVED(兜底)
   ═══════════════════════════════════════════════════════════ */
const ACG_SUB = { IDLE: 'idle', PENDING: 'pending', RESOLVED: 'resolved' };

function acgWgsHandleSubscribeClick(event, scopeId, code, targetUrl) {
  if (event) event.preventDefault();

  const root = document.getElementById(`acg-wgs-bb-${scopeId}`);
  if (!root || root.getAttribute('data-perks-enabled') !== 'true') return;

  const st = acgWgsGetState(scopeId);
  if (st.subDecisionState === ACG_SUB.PENDING) return; // 防止重复点击开多条判定通道

  // 每次全新的订阅尝试，都清空上一轮可能残留的挽留态，恢复弹层为默认内容
  st.exitWarnShown = false;
  acgWgsRestoreConfirmCard(scopeId, 'ambiguous');
  acgWgsRestoreConfirmCard(scopeId, 'unresolved');

  st.subDecisionState = ACG_SUB.PENDING;
  st.desktopBlurred = false;
  acgWgsSetPendingUI(scopeId, true);
  acgWgsStartFallbackTimer(scopeId, code); // 30s 全局兜底，防止任何路径永久挂起

  const ua = navigator.userAgent || '';
  const isInAppBrowser = /FBAN|FBAV|FB_IAB|Instagram|MicroMessenger|TikTok|Line\//i.test(ua);
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Mobile/i.test(ua);

  if (isInAppBrowser) {
    acgWgsShowYtToast(scopeId, 'Please tap "•••" and choose "Open in Browser", subscribe, then come back to this tab.');
    acgWgsStartMobileTracking(scopeId, code);
    return;
  }

  let channelId = null;
  const m = targetUrl.match(/youtube\.com\/channel\/([^/?&#]+)/i);
  if (m) channelId = m[1];

  if (!isMobile) {
    acgWgsStartDesktopFlow(scopeId, code, targetUrl);
  } else {
    acgWgsStartMobileFlow(scopeId, code, channelId, targetUrl);
  }
}

/* ── 桌面端判定通道：popup.closed 轮询(强信号) + 主窗口 blur(弱信号) ──
   注意：不读取/写入 popup 窗口的任何自定义属性——popup 指向跨域页面，
   浏览器同源策略只允许访问 closed / close() / focus() / postMessage()，
   其余访问会被拦截或静默失败，因此改用本窗口自身的 blur 事件作为弱信号。 */
function acgWgsStartDesktopFlow(scopeId, code, targetUrl) {
  const st = acgWgsGetState(scopeId);
  const popW = 500, popH = 650;
  const dualLeft = (window.screenLeft != null) ? window.screenLeft : (window.screenX || 0);
  const dualTop  = (window.screenTop  != null) ? window.screenTop  : (window.screenY || 0);
  const vpW = window.innerWidth  || document.documentElement.clientWidth  || window.screen.width;
  const vpH = window.innerHeight || document.documentElement.clientHeight || window.screen.height;
  const left = Math.round(dualLeft + Math.max(0, (vpW - popW) / 2));
  const top  = Math.round(dualTop  + Math.max(0, (vpH - popH) / 2));
  const features = [
    `width=${popW}`, `height=${popH}`,
    `left=${left}`, `top=${top}`,
    'scrollbars=yes', 'resizable=yes',
    'toolbar=no', 'menubar=no', 'location=no', 'status=no'
  ].join(',');

  const windowName = `acgWgsYTSubWindow_${scopeId}`;
  const popup = window.open(targetUrl, windowName, features);

  if (!popup || popup.closed || typeof popup.closed === 'undefined') {
    acgWgsShowYtToast(scopeId, "Popup was blocked by your browser. Please allow popups, or tap below once you've subscribed.");
    acgWgsStartMobileTracking(scopeId, code); // 退化为"返回后交互确认"通道
    return;
  }
  try { popup.focus(); } catch (e) {}

  st.desktopT0 = Date.now();
  const onBlur = () => { st.desktopBlurred = true; };
  window.addEventListener('blur', onBlur, { once: true });

  clearInterval(st.desktopPollTimer);
  st.desktopPollTimer = setInterval(() => {
    let closed = false;
    try { closed = popup.closed; } catch (e) { closed = true; } // closed 为同源白名单属性，可安全读取
    if (closed) {
      clearInterval(st.desktopPollTimer);
      st.desktopPollTimer = null;
      window.removeEventListener('blur', onBlur);
      acgWgsEvaluateDesktopOutcome(scopeId, code, Date.now() - st.desktopT0, st.desktopBlurred);
    }
  }, 300);
}

function acgWgsEvaluateDesktopOutcome(scopeId, code, dwellMs, wasBlurred) {
  const st = acgWgsGetState(scopeId);
  if (st.subDecisionState !== ACG_SUB.PENDING) return; // 已被其它通道（如30s兜底）先行解决

  if (dwellMs < 1500 && !wasBlurred) {
    // 秒关 + 主窗口从未失焦 → 高度疑似误触/老订阅者秒关，转交用户自证而非直接拒绝
    acgWgsShowAmbiguousConfirm(scopeId, code);
  } else {
    // dwell 足够长，或虽短但确实切过焦点（真实操作过 popup）
    acgWgsResolveGrant(scopeId, code);
  }
}

/* ── 移动端判定通道：visibilitychange(是否离开过) + 返回后交互探测(弱信号) ── */
function acgWgsStartMobileFlow(scopeId, code, channelId, targetUrl) {
  const st = acgWgsGetState(scopeId);
  const appUrl = channelId ? `youtube://channel/${channelId}` : null;

  if (!appUrl) {
    window.open(targetUrl, `acgWgsYTSubWindow_${scopeId}`);
    acgWgsStartMobileTracking(scopeId, code);
    return;
  }

  let appOpened = false;
  const markLeft = () => { appOpened = true; };
  window.addEventListener('pagehide', markLeft, { once: true });

  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = appUrl;
  document.body.appendChild(iframe);

  clearTimeout(st.subAttemptTimer);
  st.subAttemptTimer = setTimeout(() => {
    try { if (iframe.parentNode) iframe.parentNode.removeChild(iframe); } catch (e) {}
    window.removeEventListener('pagehide', markLeft);
    if (!appOpened && !document.hidden) {
      acgWgsShowYtToast(scopeId, "Couldn't open the YouTube app automatically. Tap below once you've subscribed.");
    }
  }, 2500);

  acgWgsStartMobileTracking(scopeId, code);
}

function acgWgsStartMobileTracking(scopeId, code) {
  const st = acgWgsGetState(scopeId);
  if (st.mobileTrackingArmed) return;
  st.mobileTrackingArmed = true;

  let leftPageConfirmed = false;
  let leftAt = null;

  const onVisChange = () => {
    if (document.hidden) {
      leftPageConfirmed = true;
      leftAt = Date.now();
    } else if (leftPageConfirmed) {
      document.removeEventListener('visibilitychange', onVisChange);
      st.mobileTrackingArmed = false;
      st._mobileVisHandler = null;
      acgWgsArmReturnActivityDetector(scopeId, code, Date.now() - leftAt);
    }
  };
  document.addEventListener('visibilitychange', onVisChange);
  st._mobileVisHandler = onVisChange;
}

function acgWgsArmReturnActivityDetector(scopeId, code, dwellAway) {
  const st = acgWgsGetState(scopeId);
  if (st.subDecisionState !== ACG_SUB.PENDING) return;

  let resolved = false;
  const detector = () => finish(true);
  function finish(hadActivity) {
    if (resolved) return;
    resolved = true;
    document.removeEventListener('touchstart', detector);
    document.removeEventListener('mousemove', detector);
    if (dwellAway >= 1500 || hadActivity) {
      acgWgsResolveGrant(scopeId, code); // 离开够久，或返回后检测到真实交互
    } else {
      acgWgsShowAmbiguousConfirm(scopeId, code); // 离开太短且无交互，存疑
    }
  }
  document.addEventListener('touchstart', detector, { once: true, passive: true });
  document.addEventListener('mousemove', detector, { once: true });
  setTimeout(() => finish(false), 3000);
}

/* ── 通用：按钮 PENDING 视觉状态 ── */
function acgWgsSetPendingUI(scopeId, isPending) {
  const root = document.getElementById(`acg-wgs-bb-${scopeId}`);
  if (!root) return;
  const btns = root.querySelectorAll('.acg-wgs-yt-cta-btn, .acg-wgs-modal-yt-btn');
  btns.forEach((btn) => btn.classList.toggle('is-pending', isPending));
}

/* ── 最终发码：唯一真正触发"发码 + 展示折扣码卡片"的入口
   同时作为所有成功路径的统一收尾点，负责把挽留态标记 / 弹层内容
   / 状态机 一次性彻底清理干净，避免任何残留导致下次点击异常。
   v6.3：新增"若本次判定通过是从挽留弹窗发起的，自动继续结账"逻辑。 ── */
function acgWgsResolveGrant(scopeId, code) {
  const st = acgWgsGetState(scopeId);
  st.subDecisionState = ACG_SUB.RESOLVED;
  st.exitWarnShown = false;
  acgWgsRestoreConfirmCard(scopeId, 'ambiguous');
  acgWgsRestoreConfirmCard(scopeId, 'unresolved');
  acgWgsClearAllSubTimers(scopeId);
  acgWgsSetPendingUI(scopeId, false);
  acgWgsHideAmbiguous(scopeId);
  acgWgsHideUnresolved(scopeId);
  acgWgsHideYtToast(scopeId);
  acgWgsMarkSubscribed(scopeId, code);
  acgWgsShowRewardUI(scopeId);

  /* v6.3：若本次发码是从"挽留弹窗 → 触发订阅"链路发起的，
     真正判定通过后自动继续结账，用户不需要再点一次购买按钮。
     这是唯一允许"发码后自动结账"的路径，且必须先经过完整的
     订阅意图判定状态机，杜绝任何绕过验证直接拿到折扣的可能。 */
  if (st.autoCheckoutAfterGrant) {
    st.autoCheckoutAfterGrant = false;
    const variantId = st.pendingCheckoutVariantId || st.activeVariantId;
    st.pendingCheckoutVariantId = null;
    acgWgsAddToCartAndRedirect(scopeId, variantId, code);
  }
}

/* ═══════════════════════════════════════════════════════════
   挽留式退出拦截（Exit-Intent）通用引擎
   适用对象：AMBIGUOUS / UNRESOLVED 两类"意图确认"弹层
   逻辑：第一次尝试静默关闭（遮罩/ESC/X）→ 原地切换为损失厌恶文案挽留；
        第二次坚持关闭 → 真正放行，完整重置状态机，允许随时重新点击订阅
   ═══════════════════════════════════════════════════════════ */

/* 缓存弹层卡片的原始 HTML，供挽留文案展示后可以复原 */
function acgWgsCacheConfirmCards(scopeId) {
  ['ambiguous', 'unresolved'].forEach(function(kind) {
    const card = document.querySelector(`#acg-wgs-${kind}-${scopeId} .acg-wgs-yt-center-card`);
    if (card && !card.dataset.originalHtml) {
      card.dataset.originalHtml = card.innerHTML;
    }
  });
}

function acgWgsRestoreConfirmCard(scopeId, kind) {
  const card = document.querySelector(`#acg-wgs-${kind}-${scopeId} .acg-wgs-yt-center-card`);
  if (card && card.dataset.originalHtml) {
    card.innerHTML = card.dataset.originalHtml;
    card.classList.remove('is-warning');
  }
}

/* 统一入口：所有"静默关闭"动作（遮罩点击 / X 按钮 / ESC）都应调用这个函数，
   而不是直接隐藏弹层——由它决定"第一次拦截挽留"还是"第二次真正放行"。 */
function acgWgsRequestDismiss(scopeId, kind) {
  const st = acgWgsGetState(scopeId);
  const modal = document.getElementById(`acg-wgs-${kind}-${scopeId}`);
  if (!modal || !modal.classList.contains('is-visible')) return;

  if (!st.exitWarnShown) {
    st.exitWarnShown = true;
    acgWgsShowExitWarning(scopeId, kind);
    return; // 拦截：弹层保持打开，只是内容换成了挽留文案
  }
  // 已经挽留过一次，用户仍坚持关闭 → 真正放行
  acgWgsFinalizeDismiss(scopeId);
}

function acgWgsShowExitWarning(scopeId, kind) {
  const card = document.querySelector(`#acg-wgs-${kind}-${scopeId} .acg-wgs-yt-center-card`);
  if (!card) return;
  const root = document.getElementById(`acg-wgs-bb-${scopeId}`);
  const discountDollars = root ? root.getAttribute('data-discount-dollars') : '20';
  const curSymbol = root ? root.getAttribute('data-currency-symbol') : '$';

  card.classList.add('is-warning');
  card.innerHTML = `
    <div class="acg-wgs-yt-center-icon" aria-hidden="true">⚠️</div>
    <p class="acg-wgs-yt-center-text">
      <strong>Not subscribed yet!</strong><br>
      Closing now means missing out on <strong>${curSymbol}${discountDollars} OFF</strong> —
      you're just one click away.
    </p>
    <div class="acg-wgs-yt-center-actions">
      <button type="button" class="acg-wgs-yt-center-link acg-wgs-yt-center-btn"
              onclick="acgWgsExitWarningRetry('${scopeId}', '${kind}')">
        Stay &amp; Claim My Discount
      </button>
      <button type="button" class="acg-wgs-yt-center-dismiss"
              onclick="acgWgsFinalizeDismiss('${scopeId}')">
        No thanks, I'll pay full price
      </button>
    </div>
  `;
}

/* 挽留成功：用户选择留下，恢复默认内容 + 重置状态机 + 自动重新触发订阅，
   减少用户还要再手动点一次的操作成本 */
function acgWgsExitWarningRetry(scopeId, kind) {
  acgWgsRestoreConfirmCard(scopeId, kind);
  const modal = document.getElementById(`acg-wgs-${kind}-${scopeId}`);
  if (modal) modal.classList.remove('is-visible');

  const st = acgWgsGetState(scopeId);
  st.exitWarnShown = false;
  acgWgsClearAllSubTimers(scopeId);
  st.subDecisionState = ACG_SUB.IDLE;
  acgWgsSetPendingUI(scopeId, false);

  const btn = document.querySelector(`#acg-wgs-action-box-${scopeId} .acg-wgs-yt-cta-btn`);
  if (btn) btn.click();
}

/* 挽留失败/用户坚持放弃：完整重置一切状态，确保订阅按钮此后仍可正常点击，
   同时清除"挽留弹窗自动结账"标记，防止用户彻底放弃订阅后残留标记
   在未来某次判定通过时被错误触发自动结账。 */
function acgWgsFinalizeDismiss(scopeId) {
  ['ambiguous', 'unresolved'].forEach(function(kind) {
    acgWgsRestoreConfirmCard(scopeId, kind);
    const modal = document.getElementById(`acg-wgs-${kind}-${scopeId}`);
    if (modal) modal.classList.remove('is-visible');
  });
  const st = acgWgsGetState(scopeId);
  st.exitWarnShown = false;
  st.autoCheckoutAfterGrant = false;   // v6.3 新增：用户放弃订阅，取消自动结账标记
  st.pendingCheckoutVariantId = null;  // v6.3 新增
  acgWgsClearAllSubTimers(scopeId);
  st.subDecisionState = ACG_SUB.IDLE;
  acgWgsSetPendingUI(scopeId, false);
}

/* ── AMBIGUOUS 弹层的"正面"操作（点击弹层内按钮，非静默关闭）── */
function acgWgsShowAmbiguousConfirm(scopeId, code) {
  const st = acgWgsGetState(scopeId);
  clearTimeout(st.resolveFallbackTimer);
  acgWgsStartFallbackTimer(scopeId, code);

  const modal = document.getElementById(`acg-wgs-ambiguous-${scopeId}`);
  if (modal) modal.classList.add('is-visible');
}
function acgWgsHideAmbiguous(scopeId) {
  const modal = document.getElementById(`acg-wgs-ambiguous-${scopeId}`);
  if (modal) modal.classList.remove('is-visible');
}
function acgWgsAmbiguousConfirm(scopeId, code) {
  acgWgsHideAmbiguous(scopeId);
  acgWgsResolveGrant(scopeId, code); // 用户自证：本人确认已订阅
}
/* "让我再试一次"：属于积极的重试行为，不触发挽留文案，直接静默重置。
   注意：不清除 autoCheckoutAfterGrant / pendingCheckoutVariantId，
   因为用户仍打算继续完成订阅，挽留弹窗发起的自动结账意图应当保留。 */
function acgWgsAmbiguousRetry(scopeId) {
  acgWgsRestoreConfirmCard(scopeId, 'ambiguous');
  const st = acgWgsGetState(scopeId);
  acgWgsHideAmbiguous(scopeId);
  acgWgsClearAllSubTimers(scopeId);
  st.exitWarnShown = false;
  st.subDecisionState = ACG_SUB.IDLE;
  acgWgsSetPendingUI(scopeId, false);
}

/* ── UNRESOLVED 弹层的"正面"操作 ── */
function acgWgsHideUnresolved(scopeId) {
  const modal = document.getElementById(`acg-wgs-unresolved-${scopeId}`);
  if (modal) modal.classList.remove('is-visible');
}
function acgWgsUnresolvedConfirm(scopeId, code) {
  acgWgsHideUnresolved(scopeId);
  acgWgsResolveGrant(scopeId, code);
}
/* "还没有，我再去看看"：同样属于积极的重试行为，静默重置，不触发挽留文案，
   同理保留 autoCheckoutAfterGrant 标记 */
function acgWgsUnresolvedRetry(scopeId) {
  acgWgsRestoreConfirmCard(scopeId, 'unresolved');
  const modal = document.getElementById(`acg-wgs-unresolved-${scopeId}`);
  if (modal) modal.classList.remove('is-visible');

  const st = acgWgsGetState(scopeId);
  st.exitWarnShown = false;
  acgWgsClearAllSubTimers(scopeId);
  st.subDecisionState = ACG_SUB.IDLE;
  acgWgsSetPendingUI(scopeId, false);
}

function acgWgsStartFallbackTimer(scopeId, code) {
  const st = acgWgsGetState(scopeId);
  clearTimeout(st.resolveFallbackTimer);
  st.resolveFallbackTimer = setTimeout(() => {
    if (st.subDecisionState === ACG_SUB.PENDING) {
      const modal = document.getElementById(`acg-wgs-unresolved-${scopeId}`);
      if (modal) modal.classList.add('is-visible');
    }
  }, 30000);
}

/* 订阅兜底提示（普通信息 toast）：手动关闭视为"放弃当前检测"，
   同样需要完整重置状态机，确保按钮可再次点击 */
function acgWgsDismissYtToastFully(scopeId) {
  acgWgsHideYtToast(scopeId);
  acgWgsFinalizeDismiss(scopeId);
}

/* ── 统一清理该 scope 下所有判定相关定时器/监听器 ── */
function acgWgsClearAllSubTimers(scopeId) {
  const st = acgWgsGetState(scopeId);
  clearInterval(st.desktopPollTimer);
  st.desktopPollTimer = null;
  clearTimeout(st.subAttemptTimer);
  clearTimeout(st.resolveFallbackTimer);
  if (st._mobileVisHandler) {
    document.removeEventListener('visibilitychange', st._mobileVisHandler);
    st._mobileVisHandler = null;
  }
  st.mobileTrackingArmed = false;
}

function acgWgsShowRewardUI(scopeId) {
  const actionBox = document.getElementById(`acg-wgs-action-box-${scopeId}`);
  const rewardCard = document.getElementById(`acg-wgs-reward-${scopeId}`);
  if (actionBox) actionBox.style.display = 'none';
  if (rewardCard) rewardCard.style.display = 'flex';
}

/* ═══════════════════════════════════════════════════════════
   订阅兜底提示 —— 中央卡片弹层：显示/隐藏
   · 不设置任何自动隐藏定时器，完全由用户点击关闭
   ═══════════════════════════════════════════════════════════ */
function acgWgsShowYtToast(scopeId, message) {
  const modal = document.getElementById(`acg-wgs-yt-toast-${scopeId}`);
  if (!modal) return;
  const textEl = document.getElementById(`acg-wgs-yt-toast-text-${scopeId}`);
  if (textEl && message) textEl.textContent = message;
  modal.classList.add('is-visible');
}

function acgWgsHideYtToast(scopeId) {
  const modal = document.getElementById(`acg-wgs-yt-toast-${scopeId}`);
  if (modal) modal.classList.remove('is-visible');
}

function acgWgsCopyCode(code, scopeId) {
  const btn = document.getElementById(`acg-wgs-code-btn-${scopeId}`);
  const tip = btn ? btn.querySelector('.acg-wgs-code-tip') : null;

  function showCopied() {
    if (tip) {
      const originalText = tip.textContent;
      tip.textContent = 'Copied! ✓';
      tip.style.background = '#86efac';
      setTimeout(() => {
        tip.textContent = originalText;
        tip.style.background = '';
      }, 2000);
    }
  }

  function legacyCopy(text) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    ta.style.pointerEvents = 'none';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); showCopied(); } catch (e) {}
    document.body.removeChild(ta);
  }

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(showCopied).catch(() => legacyCopy(code));
  } else {
    legacyCopy(code);
  }
}

function acgWgsMarkSubscribed(scopeId, code) {
  try { localStorage.setItem(`acg_vip_claimed_${scopeId}`, 'true'); } catch (e) {}
  if (code) {
    fetch(`/discount/${encodeURIComponent(code)}`, { credentials: 'same-origin' }).catch(() => {});
  }
}

function acgWgsFormatMoney(cents, formatString) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatType = formatString || '${{amount}}';
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(number) || number == null) return 0;
    number = (number / 100.0).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents2 = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents2;
  }
  const match = formatType.match(placeholderRegex);
  switch (match ? match[1] : 'amount') {
    case 'amount': value = formatWithDelimiters(cents, 2); break;
    case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
    default: value = formatWithDelimiters(cents, 2);
  }
  return formatType.replace(placeholderRegex, value);
}

function acgWgsAdjustPipSafeZone(pipEl) {
  if (!pipEl) return;
  let extraBottom = 20;
  const candidates = document.querySelectorAll(
    '[class*="sticky"][class*="cart"], [class*="sticky-add"], [id*="sticky-cart"], [class*="StickyCart"]'
  );
  candidates.forEach(function(el) {
    if (el === pipEl || pipEl.contains(el)) return;
    const cs = window.getComputedStyle(el);
    if (cs.position === 'fixed' && cs.display !== 'none') {
      const rect = el.getBoundingClientRect();
      if (rect.height > 0 && rect.bottom >= window.innerHeight - 4) {
        extraBottom = Math.max(extraBottom, rect.height + 16);
      }
    }
  });
  pipEl.style.setProperty('--acg-pip-safe-bottom', extraBottom + 'px');
}

function initAcgWgsPipDraggable(pipEl, scopeId) {
  if (!pipEl) return;
  const st = acgWgsGetState(scopeId);

  let isPointerDown = false;
  let hasDragged = false;
  let startX = 0;
  let startY = 0;
  let initialLeft = 0;
  let initialTop = 0;
  let activePointerId = null;

  function clampPosition(x, y) {
    const pipW = pipEl.offsetWidth || 135;
    const pipH = pipEl.offsetHeight || 240;
    const winW = window.innerWidth;
    const winH = window.innerHeight;
    const minX = 10;
    const maxX = winW - pipW - 10;
    const minY = 10;
    const maxY = winH - pipH - 20;
    return {
      x: Math.max(minX, Math.min(x, maxX)),
      y: Math.max(minY, Math.min(y, maxY))
    };
  }

  function snapToEdge() {
    const pipW = pipEl.offsetWidth || 135;
    const winW = window.innerWidth;
    const currentRect = pipEl.getBoundingClientRect();
    const centerX = currentRect.left + pipW / 2;

    pipEl.style.transition = 'left 0.32s cubic-bezier(0.2, 0.9, 0.3, 1), top 0.25s ease';
    pipEl.style.left = (centerX < winW / 2) ? '12px' : (winW - pipW - 12) + 'px';
    setTimeout(() => { pipEl.style.transition = ''; }, 330);
  }

  pipEl.addEventListener('pointerdown', function(e) {
    if (e.target.closest('.acg-wgs-pip-video-close-btn')) return;
    isPointerDown = true;
    hasDragged = false;
    activePointerId = e.pointerId;
    startX = e.clientX;
    startY = e.clientY;
    const rect = pipEl.getBoundingClientRect();
    initialLeft = rect.left;
    initialTop = rect.top;
    pipEl.style.left = initialLeft + 'px';
    pipEl.style.top = initialTop + 'px';
    pipEl.style.bottom = 'auto';
    pipEl.style.right = 'auto';
    try { pipEl.setPointerCapture(e.pointerId); } catch (err) {}
  });

  pipEl.addEventListener('pointermove', function(e) {
    if (!isPointerDown) return;
    const dx = e.clientX - startX;
    const dy = e.clientY - startY;
    if (!hasDragged && Math.hypot(dx, dy) > 6) {
      hasDragged = true;
      pipEl.classList.add('is-dragging');
      acgWgsPipOnHover(scopeId);
    }
    if (hasDragged) {
      const clamped = clampPosition(initialLeft + dx, initialTop + dy);
      pipEl.style.left = clamped.x + 'px';
      pipEl.style.top = clamped.y + 'px';
    }
  });

  function handlePointerUp(e) {
    if (!isPointerDown) return;
    isPointerDown = false;
    try { if (activePointerId !== null) pipEl.releasePointerCapture(activePointerId); } catch (err) {}
    pipEl.classList.remove('is-dragging');
    if (hasDragged) {
      snapToEdge();
      setTimeout(() => { hasDragged = false; }, 80);
    } else {
      acgWgsOpenDrawer(scopeId, st.pipIndex);
    }
  }

  pipEl.addEventListener('pointerup', handlePointerUp);
  pipEl.addEventListener('pointercancel', handlePointerUp);

  window.addEventListener('resize', function() {
    acgWgsAdjustPipSafeZone(pipEl);
    if (pipEl.style.left) {
      const clamped = clampPosition(parseFloat(pipEl.style.left), parseFloat(pipEl.style.top || 100));
      pipEl.style.left = clamped.x + 'px';
      pipEl.style.top = clamped.y + 'px';
      snapToEdge();
    }
  });
}

function initAcgWgsBbEngine(scopeId) {
  const root = document.getElementById(`acg-wgs-bb-${scopeId}`);
  if (!root || root.dataset.acgInit === '1') return;
  root.dataset.acgInit = '1';

  const st = acgWgsGetState(scopeId);
  st.activeVariantId = root.getAttribute('data-current-variant-id') || '';

  // 预缓存挽留弹层的原始 HTML，供后续挽留文案展示后复原
  acgWgsCacheConfirmCards(scopeId);

  st.playlist = [];
  const cards = root.querySelectorAll('.acg-wgs-bb-card');
  cards.forEach((card, index) => {
    const ytId = card.getAttribute('data-yt-id');
    if (ytId && ytId.trim() !== '') {
      st.playlist.push({ index: st.playlist.length, ytId: ytId });
      card.setAttribute('data-index', st.playlist.length - 1);
      card.onclick = function() { acgWgsOpenDrawer(scopeId, parseInt(this.getAttribute('data-index'), 10)); };
    } else {
      card.style.display = 'none';
    }
  });

  if (st.playlist.length === 0) {
    const trackBox = root.querySelector('.acg-wgs-bb-track-container');
    if (trackBox) trackBox.style.display = 'none';
    const pipEmpty = document.getElementById(`acg-wgs-pip-widget-${scopeId}`);
    if (pipEmpty) pipEmpty.style.display = 'none';
    return;
  }

  try {
    if (localStorage.getItem(`acg_vip_claimed_${scopeId}`) === 'true') {
      acgWgsShowRewardUI(scopeId);
    }
  } catch (e) {}

  const pipEl = document.getElementById(`acg-wgs-pip-widget-${scopeId}`);
  if (pipEl) {
    let pipDismissedBefore = false;
    try { pipDismissedBefore = sessionStorage.getItem(`acg_pip_dismissed_${scopeId}`) === '1'; } catch (e) {}
    if (pipDismissedBefore) {
      st.pipDismissed = true;
      pipEl.style.display = 'none';
    } else {
      acgWgsAdjustPipSafeZone(pipEl);
      initAcgWgsPipDraggable(pipEl, scopeId);
      acgWgsMaybeAutoplayPip(scopeId);
    }
  }

  if (!st.visListenerBound) {
    st.visListenerBound = true;
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        clearTimeout(st.pipTimer);
      } else if (!st.pipDismissed && !st.isHovered) {
        acgWgsScheduleNext(scopeId);
      }
    });
  }

  document.addEventListener('variant:change', function(evt) {
    if (evt.detail && evt.detail.variant) {
      acgWgsSyncFromPdp(scopeId, evt.detail.variant.id);
    }
  });

  const productForms = document.querySelectorAll('form[action*="/cart/add"]');
  productForms.forEach(form => {
    form.addEventListener('change', function() {
      const idInput = form.querySelector('[name="id"]');
      if (idInput && idInput.value) acgWgsSyncFromPdp(scopeId, idInput.value);
    });
  });

  st.pdpPollTimer = setInterval(function() {
    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (idInput && idInput.value && idInput.value != st.activeVariantId) {
      acgWgsSyncFromPdp(scopeId, idInput.value);
    }
  }, 800);
}

function acgWgsSyncFromPdp(scopeId, variantId) {
  const st = acgWgsGetState(scopeId);
  if (!variantId || variantId == st.activeVariantId) return;
  const select = document.getElementById(`acg-wgs-sheet-select-${scopeId}`);
  if (select) select.value = variantId;
  acgWgsOnVariantChange(scopeId, variantId);
}

function acgWgsMaybeAutoplayPip(scopeId) {
  const st = acgWgsGetState(scopeId);
  const pipEl = document.getElementById(`acg-wgs-pip-widget-${scopeId}`);
  if (!pipEl || st.pipAutoplayed || st.pipDismissed || st.playlist.length === 0) return;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const startWhenVisible = function() {
    if (document.visibilityState !== 'visible') {
      const onVis = function() {
        if (document.visibilityState === 'visible') {
          document.removeEventListener('visibilitychange', onVis);
          startWhenVisible();
        }
      };
      document.addEventListener('visibilitychange', onVis);
      return;
    }
    if (!st.pipAutoplayed && !st.pipDismissed) {
      st.pipAutoplayed = true;
      acgWgsPlayPipItem(scopeId, 0);
    }
  };

  setTimeout(startWhenVisible, 1200);
}

function acgWgsPlayPipItem(scopeId, index) {
  const st = acgWgsGetState(scopeId);
  const container = document.getElementById(`acg-wgs-pip-player-box-${scopeId}`);
  if (!container || st.playlist.length === 0 || st.pipDismissed) return;

  const item = st.playlist[index];
  if (!item || !item.ytId) return;
  st.pipIndex = index;

  container.style.opacity = '0';
  clearTimeout(container._acgSwapTimer);
  container._acgSwapTimer = setTimeout(function() {
    container.innerHTML = `<iframe src="https://www.youtube.com/embed/${item.ytId}?autoplay=1&mute=1&controls=0&loop=1&playlist=${item.ytId}&playsinline=1" frameborder="0" title="Product video preview"></iframe>`;
    requestAnimationFrame(function() { container.style.opacity = '1'; });
  }, 180);

  acgWgsScheduleNext(scopeId);
}

function acgWgsScheduleNext(scopeId) {
  const st = acgWgsGetState(scopeId);
  clearTimeout(st.pipTimer);
  if (!st.isHovered && !st.pipDismissed && st.playlist.length > 1 && document.visibilityState === 'visible') {
    st.pipTimer = setTimeout(() => {
      const nextIndex = (st.pipIndex + 1) % st.playlist.length;
      acgWgsPlayPipItem(scopeId, nextIndex);
    }, 25000);
  }
}

function acgWgsPipOnHover(scopeId) {
  const st = acgWgsGetState(scopeId);
  st.isHovered = true;
  clearTimeout(st.pipTimer);
}

function acgWgsPipOnLeave(scopeId) {
  const st = acgWgsGetState(scopeId);
  st.isHovered = false;
  acgWgsScheduleNext(scopeId);
}

function acgWgsDismissPip(scopeId) {
  const st = acgWgsGetState(scopeId);
  const pip = document.getElementById(`acg-wgs-pip-widget-${scopeId}`);
  st.pipDismissed = true;
  try { sessionStorage.setItem(`acg_pip_dismissed_${scopeId}`, '1'); } catch (e) {}
  if (pip) {
    pip.style.opacity = '0';
    pip.style.transform = 'scale(0.85)';
    setTimeout(() => { pip.style.display = 'none'; }, 250);
  }
  clearTimeout(st.pipTimer);
}

function acgWgsBbSlide(scopeId, dir) {
  const track = document.getElementById(`acg-wgs-track-${scopeId}`);
  if (track) track.scrollBy({ left: 100 * 2 * dir, behavior: 'smooth' });
}

function acgWgsOnVariantChange(scopeId, variantId) {
  const st = acgWgsGetState(scopeId);
  st.activeVariantId = variantId;

  const root = document.getElementById(`acg-wgs-bb-${scopeId}`);
  const dataEl = document.getElementById(`acg-wgs-variants-data-${scopeId}`);
  if (!root || !dataEl) return;

  const discountDollars = parseInt(root.getAttribute('data-discount-dollars') || '20', 10);
  const discountCents = discountDollars * 100;
  const moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  const curSymbol = root.getAttribute('data-currency-symbol') || '$';
  const rate = parseFloat(root.getAttribute('data-currency-rate') || '1') || 1;
  const perksEnabled = root.getAttribute('data-perks-enabled') === 'true';

  let variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
  const selected = variants.find(v => v.id == variantId);
  if (!selected) return;

  let vipFinalCentsBase = selected.price - discountCents;
  let clamped = false;
  if (vipFinalCentsBase < 0) { vipFinalCentsBase = selected.price; clamped = true; }

  const vipFinalCentsDisplay = Math.round(vipFinalCentsBase * rate);
  const saleCentsDisplay = Math.round(selected.price * rate);
  const compareCentsDisplay = selected.compare_at_price ? Math.round(selected.compare_at_price * rate) : 0;

  const formattedVip = acgWgsFormatMoney(vipFinalCentsDisplay, moneyFormat);
  const formattedSale = acgWgsFormatMoney(saleCentsDisplay, moneyFormat);

  const mbarVip      = document.getElementById(`acg-wgs-mbar-vip-${scopeId}`);
  const mbarSale     = document.getElementById(`acg-wgs-mbar-sale-${scopeId}`);
  const mbarPlain    = document.getElementById(`acg-wgs-mbar-plain-${scopeId}`);
  const sheetVip     = document.getElementById(`acg-wgs-sheet-vip-val-${scopeId}`);
  const sheetSale    = document.getElementById(`acg-wgs-sheet-sale-val-${scopeId}`);
  const sheetCompare = document.getElementById(`acg-wgs-sheet-compare-val-${scopeId}`);
  const modalTopVip  = document.getElementById(`acg-wgs-modal-top-vip-${scopeId}`);
  const checkoutBtn  = document.getElementById(`acg-wgs-modal-checkout-btn-${scopeId}`);
  const pipPrice     = document.getElementById(`acg-wgs-pip-price-val-${scopeId}`);
  const claimVip     = document.getElementById(`acg-wgs-claim-vip-price-${scopeId}`);
  const claimSale    = document.getElementById(`acg-wgs-claim-sale-price-${scopeId}`);

  if (mbarVip) mbarVip.textContent = `VIP: ${formattedVip}`;
  if (mbarSale) mbarSale.textContent = `Sale: ${formattedSale}`;
  if (mbarPlain) mbarPlain.textContent = formattedSale;
  if (sheetVip) sheetVip.textContent = formattedVip;
  if (sheetSale) sheetSale.textContent = formattedSale;
  if (modalTopVip) modalTopVip.textContent = formattedVip;
  if (pipPrice) pipPrice.textContent = perksEnabled ? formattedVip : formattedSale;
  if (claimVip) claimVip.textContent = formattedVip;
  if (claimSale) claimSale.textContent = formattedSale;
  if (checkoutBtn) checkoutBtn.setAttribute('data-selected-variant-id', variantId);

  if (sheetCompare) {
    if (compareCentsDisplay && compareCentsDisplay > saleCentsDisplay) {
      sheetCompare.textContent = acgWgsFormatMoney(compareCentsDisplay, moneyFormat);
      sheetCompare.style.display = '';
    } else {
      sheetCompare.style.display = 'none';
    }
  }

  const pillPrices = root.querySelectorAll('.acg-wgs-bb-pill-price');
  const pillSaves = root.querySelectorAll('.acg-wgs-bb-pill-save');
  pillPrices.forEach(el => { el.textContent = perksEnabled ? formattedVip : formattedSale; });
  if (perksEnabled) {
    pillSaves.forEach(el => {
      el.textContent = clamped ? 'Best Price' : `-${curSymbol}${discountDollars}`;
    });
  }
}

function acgWgsToggleVariantSheet(scopeId) {
  const sheet = document.getElementById(`acg-wgs-variant-sheet-${scopeId}`);
  if (sheet) sheet.classList.toggle('is-open');
}

function acgWgsOpenDrawer(scopeId, index) {
  const st = acgWgsGetState(scopeId);
  const drawer = document.getElementById(`acg-wgs-drawer-${scopeId}`);
  const player = document.getElementById(`acg-wgs-drawer-player-${scopeId}`);
  const item = st.playlist[index];
  if (!drawer || !player || !item || !item.ytId) return;

  st.lastFocus = document.activeElement;
  player.innerHTML = `<iframe src="https://www.youtube.com/embed/${item.ytId}?autoplay=1&playsinline=1" allow="autoplay" allowfullscreen title="Product video"></iframe>`;
  drawer.classList.add('is-active');
  document.body.style.overflow = 'hidden';
  const frame = player.querySelector('iframe');
  if (frame) { frame.setAttribute('tabindex', '-1'); frame.focus(); }
}

function acgWgsCloseDrawer(scopeId) {
  const st = acgWgsGetState(scopeId);
  const drawer = document.getElementById(`acg-wgs-drawer-${scopeId}`);
  const player = document.getElementById(`acg-wgs-drawer-player-${scopeId}`);
  const sheet = document.getElementById(`acg-wgs-variant-sheet-${scopeId}`);
  if (sheet) sheet.classList.remove('is-open');
  if (drawer) drawer.classList.remove('is-active');
  if (player) player.innerHTML = '';
  document.body.style.overflow = '';
  if (st.lastFocus && st.lastFocus.focus) { try { st.lastFocus.focus(); } catch (e) {} }
  st.lastFocus = null;
}

function acgWgsAddToCartAndRedirect(scopeId, variantId, discountCode) {
  if (!variantId) return;
  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
  })
    .then(function(res) {
      if (!res.ok) throw new Error('acg_cart_add_failed');
      return res.json();
    })
    .then(function() {
      if (discountCode) {
        window.location.href = `/discount/${encodeURIComponent(discountCode)}?redirect=%2Fcheckout`;
      } else {
        window.location.href = '/checkout';
      }
    })
    .catch(function() {
      window.location.href = `/cart/${variantId}:1`;
    });
}

/* v6.3：唯一合法的"未订阅时点击购买"入口。
   若用户已订阅过（localStorage 标记为真），直接带折扣码结账；
   若尚未订阅，只弹出说明性质的挽留弹窗（不发码），把用户想买的
   variant 记录下来，交由 acgWgsClaimModalSubscribeAndCheckout()
   在真正走完订阅判定流程后才继续。 */
function acgWgsHandleBuyClick(scopeId, code, variantId) {
  const root = document.getElementById(`acg-wgs-bb-${scopeId}`);
  const st = acgWgsGetState(scopeId);
  const targetVariantId = variantId || st.activeVariantId;
  const perksEnabled = root && root.getAttribute('data-perks-enabled') === 'true';

  if (!perksEnabled) {
    acgWgsAddToCartAndRedirect(scopeId, targetVariantId, null);
    return;
  }

  let isClaimed = false;
  try { isClaimed = localStorage.getItem(`acg_vip_claimed_${scopeId}`) === 'true'; } catch (e) {}

  if (isClaimed) {
    acgWgsAddToCartAndRedirect(scopeId, targetVariantId, code);
  } else {
    st.pendingCheckoutVariantId = targetVariantId; // 记住待结账商品，供订阅判定通过后自动继续
    const claimModal = document.getElementById(`acg-wgs-claim-modal-${scopeId}`);
    if (claimModal) claimModal.style.display = 'flex';
    else acgWgsAddToCartAndRedirect(scopeId, targetVariantId, null);
  }
}

function acgWgsCloseClaimModal(scopeId) {
  const claimModal = document.getElementById(`acg-wgs-claim-modal-${scopeId}`);
  if (claimModal) claimModal.style.display = 'none';
}

/* v6.3 新增（替代已删除的漏洞函数 acgWgsApplyAndCheckout）：
   挽留弹窗"Subscribe & Unlock"按钮的唯一合法处理函数。
   不在此处发码，而是关闭挽留弹窗后，程序化点击真正的订阅按钮，
   完整复用 PENDING → HIGH_CONF / AMBIGUOUS / UNRESOLVED 判定流程。
   只有 acgWgsResolveGrant() 真正被调用（即判定通过）时，才会
   借助 autoCheckoutAfterGrant 标记自动继续结账。 */
function acgWgsClaimModalSubscribeAndCheckout(scopeId) {
  const st = acgWgsGetState(scopeId);
  acgWgsCloseClaimModal(scopeId);
  st.autoCheckoutAfterGrant = true;

  const subBtn = document.querySelector(`#acg-wgs-action-box-${scopeId} .acg-wgs-yt-cta-btn`);
  if (subBtn) {
    subBtn.click(); // 复用真实订阅按钮的点击处理器，触发完整判定状态机
  } else {
    // 极端兜底：找不到订阅按钮时，不发码，只带用户去结账（无折扣），
    // 避免因 DOM 结构异常而导致流程卡死或误发折扣
    st.autoCheckoutAfterGrant = false;
    acgWgsAddToCartAndRedirect(scopeId, st.pendingCheckoutVariantId, null);
  }
}

function acgWgsSkipToCheckout(scopeId) {
  const st = acgWgsGetState(scopeId);
  const variantId = st.pendingCheckoutVariantId || st.activeVariantId;
  st.pendingCheckoutVariantId = null;
  st.autoCheckoutAfterGrant = false;
  acgWgsAddToCartAndRedirect(scopeId, variantId, null);
}

/* ═══════════════════════════════════════════════════════════
   自举初始化：扫描页面上所有 .acg-wgs-bb-wrapper[data-scope-id] 实例
   ═══════════════════════════════════════════════════════════ */
function acgWgsInitAll(scopeEl) {
  const roots = (scopeEl || document).querySelectorAll('.acg-wgs-bb-wrapper[data-scope-id]');
  roots.forEach(function(root) {
    const scopeId = root.getAttribute('data-scope-id');
    if (scopeId) initAcgWgsBbEngine(scopeId);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { acgWgsInitAll(); });
} else {
  acgWgsInitAll();
}

document.addEventListener('shopify:section:load', function(evt) {
  acgWgsInitAll(evt.target);
});

if (!window.acgWgsGlobalKeysBound) {
  window.acgWgsGlobalKeysBound = true;

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;

    let anyDrawerOpen = false;
    document.querySelectorAll('.acg-wgs-drawer.is-active').forEach(function(d) {
      anyDrawerOpen = true;
      d.classList.remove('is-active');
      const p = d.querySelector('.acg-wgs-drawer-video-frame');
      if (p) p.innerHTML = '';
      const s = d.querySelector('.acg-wgs-variant-sheet');
      if (s) s.classList.remove('is-open');
    });
    document.querySelectorAll('.acg-wgs-claim-modal').forEach(function(m) {
      m.style.display = 'none';
    });

    // AMBIGUOUS / UNRESOLVED 弹层的 ESC 关闭，必须走统一的挽留拦截逻辑
    // （第一次拦截挽留，第二次才真正放行+重置状态机），而不能简单隐藏——
    // 那正是此前导致按钮永久卡死的根因。
    document.querySelectorAll('.acg-wgs-confirm-modal.is-visible').forEach(function(m) {
      const idParts = m.id.match(/^acg-wgs-(ambiguous|unresolved)-(.+)$/);
      if (idParts) {
        acgWgsRequestDismiss(idParts[2], idParts[1]);
      } else {
        m.classList.remove('is-visible');
      }
    });

    // 普通信息类提示（订阅兜底 toast）：ESC 直接关闭 + 完整重置状态机
    document.querySelectorAll('.acg-wgs-yt-center-modal.is-visible:not(.acg-wgs-confirm-modal)').forEach(function(m) {
      const idParts = m.id.match(/^acg-wgs-yt-toast-(.+)$/);
      m.classList.remove('is-visible');
      if (idParts) acgWgsFinalizeDismiss(idParts[1]);
    });

    if (anyDrawerOpen) document.body.style.overflow = '';
  });

  const acgWgsCleanupAllTimers = function() {
    Object.keys(window.acgWgsState || {}).forEach(function(sid) {
      const st = window.acgWgsState[sid];
      if (!st) return;
      clearInterval(st.pdpPollTimer);
      clearTimeout(st.pipTimer);
      clearTimeout(st.subAttemptTimer);
      clearInterval(st.desktopPollTimer);
      clearTimeout(st.resolveFallbackTimer);
      if (st._mobileVisHandler) {
        document.removeEventListener('visibilitychange', st._mobileVisHandler);
        st._mobileVisHandler = null;
      }
    });
  };
  window.addEventListener('pagehide', acgWgsCleanupAllTimers);
  document.addEventListener('shopify:section:unload', function() {
    Object.keys(window.acgWgsState || {}).forEach(function(sid) {
      if (!document.getElementById(`acg-wgs-bb-${sid}`)) {
        const st = window.acgWgsState[sid];
        if (st) {
          clearInterval(st.pdpPollTimer);
          clearTimeout(st.pipTimer);
          clearTimeout(st.subAttemptTimer);
          clearInterval(st.desktopPollTimer);
          clearTimeout(st.resolveFallbackTimer);
          if (st._mobileVisHandler) {
            document.removeEventListener('visibilitychange', st._mobileVisHandler);
          }
        }
        delete window.acgWgsState[sid];
      }
    });
  });
}